import React, {useEffect, useState} from "react";
import SalaryEdit from "../../../../../entities/DashboardPage/HRModule/SalaryManagementPage/SalaryEdit";
import LoaderHelper from "../../../../../utils/Loader/LoaderHelper";
import AuthService from "../../../../../api/AuthService";
import { useLocation, useNavigate } from "react-router-dom";
import { useAlert } from "../../../../../context/AlertContext";
import { getBlobErrorMessage } from "../../../../../utils/blobError";

const SalaryEditPage = () => {
  const { showAlert } = useAlert();
  const {state} = useLocation();
  const {item}=state ||{};
  useEffect(() => {
    if(item?._id){

      getPayrollPayslip(item?._id);
      getPayslipSetting();
    }
  },[])
  const [loading, setLoading] = useState();
  const [pensiondata,setpensiondata] = useState([]);
  const [allowanceData,setallowanceData] = useState([]);
  const [contribution,setContribution] =useState([])
  const [levieData,setLevieData] = useState([]);
  const [fringeData,setFringeData] = useState([]);
  const [loanData,setLoanData] = useState([]);
  const [deductionData,setDeductionData] = useState([]);
  const [leaveData,setLeaveData] = useState([]);
  const [payslip, setPayslip] =useState([]);
  const [data,setData] = useState(item);
  const navigate = useNavigate();

  const getPayrollPayslip =async (id) => {
    LoaderHelper.loaderStatus(true);

    try {
      const result = await AuthService.getPayrollPayslip(id,);

      if (result?.success) {
        setData(result?.data?.[0]);
        LoaderHelper.loaderStatus(false);
      } else {

        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {

      LoaderHelper.loaderStatus(false);
    }
  };

  const getPensionList =async () => {
    LoaderHelper.loaderStatus(true);

    try {
      const result = await AuthService.getPensionList(item?.employee, item?.payroll);
      if (result?.success) {
        setpensiondata(result?.data?.pension);
        LoaderHelper.loaderStatus(false);
      } else {

        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {

      LoaderHelper.loaderStatus(false);
    }
  };
  const getAllowanceList =async () => {
    LoaderHelper.loaderStatus(true);

    try {
      const result = await AuthService.getAllowanceList(item?.employee, item?.payroll);
      if (result?.success) {
        setallowanceData(result?.data?.allowance);
        LoaderHelper.loaderStatus(false);
      } else {

        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {

      LoaderHelper.loaderStatus(false);
    }
  };
  const getLevieList =async () => {
    LoaderHelper.loaderStatus(true);

    try {
      const result = await AuthService.getLevieList(item?.employee,item?.payroll);
      if (result?.success) {
        setLevieData(result?.data?.levie);
        LoaderHelper.loaderStatus(false);
      } else {

        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {

      LoaderHelper.loaderStatus(false);
    }
  };
  const getFringeList =async () => {
    LoaderHelper.loaderStatus(true);

    try {
      const result = await AuthService.getFringeList(item?.employee,item?.payroll);
      if (result?.success) {
        setFringeData(result?.data?.fringes);
        LoaderHelper.loaderStatus(false);
      } else {

        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {

      LoaderHelper.loaderStatus(false);
    }
  };
  const getLoanList =async () => {
    LoaderHelper.loaderStatus(true);

    try {
      const result = await AuthService.getLoanPayslip(item?.employee, item?.payroll);
      if (result?.success) {
        setLoanData(result?.data?.loans);
        LoaderHelper.loaderStatus(false);
      } else {

        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {

      LoaderHelper.loaderStatus(false);
    }
  };
  const getDeductionList =async () => {
    LoaderHelper.loaderStatus(true);

    try {
      const result = await AuthService.getDeductionPayslip(item?.payroll);
      if (result?.success) {
        setDeductionData(result?.data?.deductions);
        LoaderHelper.loaderStatus(false);
      } else {

        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {

      LoaderHelper.loaderStatus(false);
    }
  };
  const getLeave =async (id) => {
    LoaderHelper.loaderStatus(true);

    try {
      const result = await AuthService.getLeavePayslip(id, data?.payroll?.createdAt, data?.payroll?.end);
      if (result?.success) {
        setLeaveData(result?.data);
        LoaderHelper.loaderStatus(false);
      } else {

        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {

      LoaderHelper.loaderStatus(false);
    }
  };
  const getPayslipSetting = async () => {
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.getPayslipSetting();
      if (result?.success) {
        setPayslip(result?.data);

        LoaderHelper.loaderStatus(false);

        // console.log(result,"result getemployee")
      } else {
        LoaderHelper.loaderStatus(false);
        // console.log(result?.message, "kjshakjh");
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
      // console.error("Error occurred:", error);
    }
  };
  const handleUpdate = async (user,travelValue) => {
    setLoading(true);
    try {
      const result = await AuthService.handlePayslip(item?._id, user,"",travelValue);
      if (result?.success === true) {
        setLoading(false);
        getPayrollPayslip(item?._id);
        
        showAlert(result?.message, "success");
        navigate(-1);
      } else {
        setLoading(false);
        showAlert(result?.message, "error");
      }
    } catch (error) {
      setLoading(false);
      showAlert(error, "error");
    }
  };

  const handleSalaryReport = async () => {
    LoaderHelper.loaderStatus(true);
    setLoading(true);

    try {
      const result = await AuthService.handleSalaryReport(item?._id);
      
      if (!result) {
        setLoading(false);
        LoaderHelper.loaderStatus(false);
        showAlert(result?.message, "error");
      } else {
        const downloadError = await getBlobErrorMessage(result);
        if (downloadError) {
          setLoading(false);
          LoaderHelper.loaderStatus(false);
          showAlert(downloadError, "error");
          return;
        }
        const blob = new Blob([result], { type:  "application/pdf"});
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `FileName.${"pdf"}`);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        setLoading(false);
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      setLoading(false);
      LoaderHelper.loaderStatus(false);
    }
  };

  const getContribution =async () => {
    LoaderHelper.loaderStatus(true);

    try {
      const result = await AuthService.getContributionEdit(item?.employee, item?.payroll);
      if (result?.success) {
        setContribution(result?.data?.contribution);
        LoaderHelper.loaderStatus(false);
      } else {

        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {

      LoaderHelper.loaderStatus(false);
    }
  };
  return (
    
    <SalaryEdit getLeave={getLeave} leaveData={leaveData} getLoanList={getLoanList} getDeductionList={getDeductionList} deductionData={deductionData} loanData={loanData}  data={data} getPensionList={getPensionList} pensionData={pensiondata} getAllowanceList={getAllowanceList} allowanceData={allowanceData} getLevieList={getLevieList} levieData={levieData} 
      getFringeList={getFringeList} fringeData={fringeData} payslip={payslip} loading={loading} handleUpdate={handleUpdate}
      handleSalaryReport={handleSalaryReport} getContribution={getContribution} contribution={contribution}/>
  )


}

export default SalaryEditPage;
